<template>
  <span class="facility" :class="{ 'max-persons-exceeded': isOverCapacity }">
    <template v-if="capacityDisplay === 'unlimited'">
      <img
        loading="lazy"
        src="@/assets/images/group.svg"
        width="15"
        height="18"
        alt=""
      />
      <translate>Max. persons unlimited</translate>
    </template>
    <template v-else>
      <img
        v-if="capacityDisplay === '1'"
        loading="lazy"
        src="@/assets/images/adult.svg"
        width="16"
        height="16"
        alt=""
      />
      <img
        v-else-if="capacityDisplay === '2'"
        loading="lazy"
        src="@/assets/images/adults.svg"
        width="15"
        height="17"
        alt=""
      />
      <img
        v-else
        loading="lazy"
        src="@/assets/images/group.svg"
        width="15"
        height="18"
        alt=""
      />
      <translate v-if="isNumber" :tt="{ capacity: capacityDisplay }"
        >{capacity} people maximum</translate
      >
      <translate v-else>Unlimited people</translate>
    </template>
    <pu-popover v-if="ageRestrictions && ageRestrictions.length > 0">
      <template #content>
        <translate tag="h4">Party size restrictions</translate>
        <capacity-rules :age-restrictions="ageRestrictions" />
      </template>
    </pu-popover>
  </span>
</template>

<script lang="ts">
import { AgeRestrictions } from '~/apps/campsite-details/types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class Capacity extends Vue {
  @Prop()
  capacityDisplay: string

  @Prop()
  isOverCapacity: boolean

  @Prop()
  ageRestrictions: AgeRestrictions

  get isNumber() {
    return !isNaN(parseInt(this.capacityDisplay))
  }
}

export default toNative(Capacity)
</script>
<style scoped>
img {
  height: 1.2em;
  width: auto;
  vertical-align: sub;
}
</style>
